function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import classNames from 'classnames';
import notifier from 'components/notifier/assets/css/notifier.module.scss';
import React, { useEffect, useRef } from 'react';
import { Variant } from 'components/notifier/types/Variant';
import { useNotifier } from 'components/notifier/hooks/useNotifier';
import { CSSTransition } from 'react-transition-group';

var Item = function Item(_ref) {
  var id = _ref.id,
      message = _ref.message,
      isVisible = _ref.isVisible,
      _ref$timeout = _ref.timeout,
      timeout = _ref$timeout === void 0 ? 3000 : _ref$timeout,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? Variant.black : _ref$variant;

  var _useNotifier = useNotifier(),
      notifierHide = _useNotifier.notifierHide;

  var timeoutId = useRef();

  var clearTimeout = function clearTimeout() {
    if (timeoutId) {
      window.clearTimeout(timeoutId.current);
    }
  };

  var hide = function hide() {
    notifierHide(id);
    clearTimeout();
  };

  var startTimeout = function startTimeout() {
    if (timeout) {
      timeoutId.current = window.setTimeout(function () {
        hide();
      }, timeout);
    }

    return function () {
      clearTimeout();
    };
  };

  useEffect(function () {
    if (!isVisible) {
      return function () {
        return undefined;
      };
    }

    return startTimeout();
  }, [isVisible]);

  var handlerTransitionExited = function handlerTransitionExited() {
    notifierHide(id, true);
  };

  return /*#__PURE__*/React.createElement(CSSTransition, {
    "in": isVisible,
    timeout: 300,
    classNames: notifier.notifier__item,
    onExited: handlerTransitionExited
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames(notifier.notifier__item, _defineProperty({}, notifier.notifier__itemBlack, variant === Variant.black)),
    onMouseLeave: hide
  }, message));
};

export { Item };